import './../src/storybook/theme/theme.css';
import { Copernicus } from './../src/main';

Object.assign(window, { Copernicus });
